import axios from 'axios';
import React, { useEffect } from 'react';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SlArrowLeft } from 'react-icons/sl';
import { BASE_URL } from '../../insightConfig/insightConfig';

const UGC_Resources = () => {
    const [downloads, setDownloads] = React.useState([]);
    useEffect(() => {
        axios.get(BASE_URL + '/ugc/user/resources').then((response) => {
            setDownloads(response.data.data);
        }
        ).catch((error) => {
            console.error("There was an error fetching the data!", error);
        });
    }, []);

    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div className='mx-'>
            <SeoHelmets 
                title="UGC NET Study Resources | Download Materials - Insight IAS" 
                description="Download important resources, study materials, and subject guides for UGC NET preparation. Free materials from Insight IAS Delhi."
                keywords="UGC NET resources, NET study material, JRF preparation guide, UGC NET syllabus download"
            />
            <div className='History-container-box'>
                <div className='card History-card container'>
                    <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm w-100">
                        <button
                            className="btn btn-sm"
                            style={{
                                backgroundColor: '#17a2b8',
                                color: 'white',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                padding: '4px 12px',
                                border: 'none',
                                borderRadius: '4px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                cursor: 'pointer'
                            }}
                            onClick={() => navigate(-1)}
                        >
                            <SlArrowLeft className='me-1' /> Back
                        </button>
                        <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>UGC Resources</h2>
                        <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'ugc_net' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                    </div>
                    {/* Course Table Start */}
                    <table className="table shadow-sm align-middle" border="1">
                        <thead>
                            <tr className='text-center'>
                                <th colSpan="4" className='History1-course-heading table-border fw-bold'>IMPORTANT RESOURCES FOR UGC-NET PREPARATION</th>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <th className='History2-course-heading table-border fw-semibold'>S.No.</th>
                                <th className='History2-course-heading table-border fw-semibold'>File Name</th>
                                <th className='History2-course-heading table-border fw-semibold'>DownLoad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {downloads?.map((course, index) => (
                                <tr key={index}>
                                    <td className='table-border text-center'>{index + 1}</td>
                                    <td className='table-border table-data2'>{course.FileTitle}</td>
                                    <td className='table-border text-center'>
                                        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '40px' }}>
                                            <button
                                                className='btn btn-danger btn-sm'
                                                style={{
                                                    fontWeight: 'bold',
                                                    padding: '6px 20px',
                                                    backgroundColor: '#dc3545',
                                                    color: 'white',
                                                    border: 'none',
                                                    display: 'inline-block'
                                                }}
                                                onClick={() => window.open(course.FilePath)}
                                            >
                                                DOWNLOAD
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* Course Table End */}
                </div>
            </div>
        </div>
    )
}

export default UGC_Resources;